import './App.css';
import { ProvideAuth } from './hooks/useAuth';
import { ProvideNotification } from './context';
import { ReactQueryProvider } from './lib/react-query';
import Outlet from './routes/Outlet';

function App() {
  return (
    <ReactQueryProvider>
      <ProvideNotification>
        <ProvideAuth>
          <Outlet />
        </ProvideAuth>
      </ProvideNotification>
    </ReactQueryProvider>
  );
}

export default App;
